module.exports = __webpack_public_path__ + "static/media/micro-altimeter.9af6a690.jpg";